import script from "./ResultsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsIndex.vue?vue&type=script&setup=true&lang=js"

import "./ResultsIndex.vue?vue&type=style&index=0&id=7c918bae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c918bae"]])

export default __exports__